/* eslint-disable */
import { HintsType } from '../ContactSearchPanelEnum';
export default {
  [HintsType.thirdPartyNoRecordsContent]:
    'Entrez au moins {minimumLength} lettres ou chiffres pour rechercher parmi tous les enregistrements dans {sourceName}.',
  [HintsType.noFilterOrSearchRecordsTitle]: 'Aucun résultat trouvé',
  [HintsType.noFilterOrSearchRecordsContent]:
    'Vérifiez les résultats des autres sources ou changez votre mot-clé.',
  [HintsType.searching]: 'Recherche…',
  companyTabTitle: 'Entreprise',
  personalTabTitle: 'Personnel',
  direct: 'Direct',
  extension: 'Poste',
  contact: 'Contact',
  mobile: 'Cellulaire',
  company: 'Entreprise',
  home: 'Domicile',
  home2: 'Domicile',
  other: 'Autre',
  business: 'Professionnel',
  business2: 'Professionnel',
  car: 'Voiture',
  fax: 'Télécopieur',
  assistant: 'Assistant',
  callback: 'Rappel',
  MobileNumber: 'Numéro de cellulaire',
  ContactNumber: 'Numéro de contact',
  DirectNumber: 'Numéro direct',
  doNotCall: 'Ne pas appeler',
} as const;

// @key: @#@"[HintsType.thirdPartyNoRecordsContent]"@#@ @source: @#@"Enter at least {minimumLength} characters or digits to search all {sourceName} records."@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsTitle]"@#@ @source: @#@"No results found"@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsContent]"@#@ @source: @#@"Check results from other sources or change your keyword."@#@
// @key: @#@"[HintsType.searching]"@#@ @source: @#@"Searching..."@#@
// @key: @#@"companyTabTitle"@#@ @source: @#@"Company"@#@
// @key: @#@"personalTabTitle"@#@ @source: @#@"Personal"@#@
// @key: @#@"direct"@#@ @source: @#@"Direct"@#@
// @key: @#@"extension"@#@ @source: @#@"Ext"@#@
// @key: @#@"contact"@#@ @source: @#@"Contact"@#@
// @key: @#@"mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"home"@#@ @source: @#@"Home"@#@
// @key: @#@"home2"@#@ @source: @#@"Home"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"business"@#@ @source: @#@"Business"@#@
// @key: @#@"business2"@#@ @source: @#@"Business"@#@
// @key: @#@"car"@#@ @source: @#@"Car"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"assistant"@#@ @source: @#@"Assistant"@#@
// @key: @#@"callback"@#@ @source: @#@"Callback"@#@
// @key: @#@"MobileNumber"@#@ @source: @#@"Mobile Number"@#@
// @key: @#@"ContactNumber"@#@ @source: @#@"Contact Number"@#@
// @key: @#@"DirectNumber"@#@ @source: @#@"Direct Number"@#@
// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
